import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const sleepApnea: AnswerPathTreeNode = {
  path: 'sleepApnea',
  children: [
    { path: 'symptomsSeverity', nodeId: NodeIds.healthInsuredSleepApneaSymptomsSeverity },
    {
      path: 'cpapTreatment',
      children: [
        { path: 'usageHours', nodeId: NodeIds.healthInsuredCpapTreatmentUsageHours },
        { path: 'usageWeek', nodeId: NodeIds.healthInsuredCpapTreatmentUsageWeek },
        { path: 'isControlled', nodeId: NodeIds.healthInsuredCpapTreatmentIsControlled },
        { path: 'treatment', nodeId: NodeIds.healthInsuredCpapTreatment },
        { path: 'noTreatmentReason', nodeId: NodeIds.healthInsuredCpapNoTreatmentReason },
        { path: 'noTreatmentReasonOtherTreatment', nodeId: NodeIds.healthInsuredCpapNoTreatmentReasonOtherTreatment },
        { path: 'noTreatmentReasonOther', nodeId: NodeIds.healthInsuredCpapNoTreatmentReasonOther },
      ],
    },
    {
      path: 'obstrusiveSleepApnea',
      children: [{ path: 'diagnosisDate', nodeId: NodeIds.healthInsuredObstrusiveSleepApneaDiagnosisDate }],
    },
  ],
};
